import apis from "../../apis";
import { update } from "../utils";

export default {
  namespaced: true,
  state: {
    serviceChannel: {},
    onlyService: false,
    merchantCode: "",
    serviceUrl: "",
    showServiceIframe: false,
    serviceIsFix: false,
  },
  actions: {
    fetch(context) {
      return new Promise((resolve) => {
        apis.app.getService().then((response) => {
          let data = response.data;
          data.onlyService = data.serviceChannel.length == 1,
          context.commit("update", data);
          return resolve(response);
        });
      });
    },
    showService(context, payload) {
      context.commit("TOGGLE_FULL_SCREEN_LOADING", true, { root: true });
      // 內部調用dispatch 不用給namespace
      context.dispatch('fetch').then((response) => {
        let data = response.data.serviceChannel;
        data.forEach(element => {
          if(element.item == "serviceOnline24" || element.item == 'serviceOnline12'){
            if (element.openLink == 1) {
              context.commit("TOGGLE_FULL_SCREEN_LOADING", false, { root: true });
              let link = document.createElement('a');
              link.target = '_blank';
              link.href = element.serviceUrl;
              link.click();
            } else {
              context.commit("TOGGLE_FULL_SCREEN_LOADING", true, { root: true });
              apis.getCustomerServiceIframeUrl({...payload, link: element.serviceUrl, lang: context.rootState.app.lang.key}).then((res) => {
                const serviceIsFix = !element.serviceUrl
                context.commit("update", {
                  merchantCode: response.data.merchantCode,
                  serviceUrl: res.data.url,
                  showServiceIframe: !serviceIsFix,
                  serviceIsFix
                });
                context.commit("TOGGLE_FULL_SCREEN_LOADING", false, { root: true });
                return Promise.resolve(res.data.url);
              });
            }
          }
        });
      });
      context.commit("TOGGLE_FULL_SCREEN_LOADING", false, { root: true });
    }
  },
  mutations: {
    update,
  },
  getters: {
    onlyService(state) {
      return state.onlyService;
    }
  }
};
